import { List, Map, OrderedMap } from 'immutable'
import Cookies from 'js-cookie'

import {
  LOGIN,
  FETCH_CURRENT_USER,
  DESELECT,
  SELECT,
  DESELECT_ALL,
  EDIT_USER,
  ZOOM,
  CREATE_VIDEO,
  DELETE_VIDEO,
} from '../actions'

const initialState = {
  loading_plan: false,
  loggingIn: false,
  selected: new List(),
  uploads: 0,
  isFetching: true,
  embed_options: new Map(),
  ua: typeof navigator !== 'undefined' ? navigator.userAgent : null,
  user_name: Cookies.get("user_name"),
  dark_mode: Cookies.get("dark_mode") == 'true',
  version: process.env.REACT_APP_VERSION || 'unknown',
  plan: Cookies.get("plan"),
  first_run: !Cookies.get('dashboard')
}

export default function me(state = initialState, action) {
  switch (action.type) {
    case LOGIN:
      if (action.error) {
        return {
          ...state,
          loggingIn: false,
          error: true,
          message: action.payload.message,
        }
      }
      return {
        ...state,
        ...action.payload,
      }
    case FETCH_CURRENT_USER:
      if (action.error) {
        return {
          ...state,
          user_name: null,
          isFetching: false,
        }
      }
      return {
        ...state,
        ...action.payload,
        isFetching: false,
      }
    case DESELECT:
      return {
        ...state,
        selected: state.selected.delete(state.selected.indexOf(action.payload)),
      }
    case SELECT:
      if (Array.isArray(action.payload)) {
        return {
          ...state,
          selected: new List(action.payload),
        }
      }
      return {
        ...state,
        selected: state.selected.push(action.payload),
      }
    case DESELECT_ALL:
      return {
        ...state,
        selected: new List(),
      }
    case EDIT_USER:
      if (action.error) {
        return {
          ...state,
          error: true,
          message: action.payload.message,
          isFetching: false,
        }
      }
      return {
        ...state,
        isFetching: false,
        ...action.payload,
      }
    case ZOOM:
      return {
        ...state,
        zoomed: action.payload,
      }
    case CREATE_VIDEO:
      return {
        ...state,
        uploads: state.uploads + 1,
      }
    case DELETE_VIDEO:
      return {
        ...state,
        selected: state.selected.delete(state.selected.indexOf(action.payload.shortcode)),
      }
    default:
      return state
  }
}
